import Vue from 'vue';
import Vuex from 'vuex';
import ky from 'ky';
import getVideoIdFromURL from './getVideoIdFromURL';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    movies: [],
    carouselBanners: [],
    showTrailerModal: false,
    showMovieModal: false,
    trailerModalVideoId: '',
    movieModal: null,
    movieModalVideoId: '',
    snacks: [],
    promotions: [],
  },
  getters: {
    billboardMovies: state => state.movies.filter(movie => movie.category[0] === 'now-playing'),
    comingMovies: state => state.movies.filter(movie => movie.category[0] === 'coming-soon').reverse(),
    carouselMovies: state => state.movies.filter(movie => movie['show-in-carousel'] === '1'),
    modalTrailerState: state => !!state.showTrailerModal,
    modalMovieState: state => !!state.showMovieModal,
    modalTrailerIframe: state => `
      <iframe 
      src="https://www.youtube.com/embed/${state.trailerModalVideoId}"
      type="text/html"
      width="100%"
      height="auto"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen></iframe>`,
    modalMovieIframe: state => `
      <iframe 
      src="https://www.youtube.com/embed/${state.movieModalVideoId}"
      type="text/html"
      width="100%"
      height="auto"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen></iframe>`,
  },
  mutations: {
    setMovies(state, movies) {
      state.movies = movies;
    },
    setBanners(state, banners) {
      state.carouselBanners = banners;
    },
    setTrailerModalState(state, show) {
      state.showTrailerModal = show;
    },
    setMovieModalState(state, show) {
      state.showMovieModal = show;
    },
    setTrailerModalVideoId(state, videoId) {
      state.trailerModalVideoId = videoId;
    },
    setMovieModalVideoId(state, videoId) {
      state.movieModalVideoId = videoId;
    },
    setMovieModal(state, movie) {
      state.movieModal = movie;
    },
    setSnacks(state, snacks) {
      state.snacks = snacks;
    },
  },
  actions: {
    async getMovies({ commit }) {
      const fields = 'id,movie-name,short-plot,synopsis,runtime,year,rating,showtimes,trailer,details,poster,logo,backdrop,preview,show-in-carousel,category';
      const movies = await ky.get(`https://admin.cineflick.com.gt/wp-json/wp/v2/movie?_fields=${fields}`).json();
      commit('setMovies', movies);
    },
    async getBanners({ commit }) {
      const fields = 'id,banner-title,description,image';
      const banners = await ky.get(`https://admin.cineflick.com.gt/wp-json/wp/v2/banner?_fields=${fields}`).json();
      commit('setBanners', banners);
    },
    async getSnacks({ commit }) {
      const fields = 'id,snack-title,description,image';
      const snacks = await ky.get(`https://admin.cineflick.com.gt/wp-json/wp/v2/snack?_fields=${fields}`).json();
      commit('setSnacks', snacks.reverse());
    },
    openTrailerModal({ commit }, trailer) {
      const videoId = getVideoIdFromURL(trailer);
      commit('setTrailerModalVideoId', videoId);
      commit('setTrailerModalState', true);
    },
    closeTrailerModal({ commit }) {
      commit('setTrailerModalState', false);
    },
    openMovieModal({ commit }, movie) {
      commit('setMovieModal', movie);
      const videoId = getVideoIdFromURL(movie.trailer);
      commit('setMovieModalVideoId', videoId);
      commit('setMovieModalState', true);
    },
    closeMovieModal({ commit }) {
      commit('setMovieModalState', false);
    },
  },
});
